import { PatientInfoType } from "DataTypes/Redux";
import { addPatientInfo } from "Redux/Patient/Action";
import PatientApi from "Service/Patient.api";
import PatientFormatter from "./Patient.Formatter";

/**
 * Re-reads the patient's demographics from our system and pushes them back into
 * Redux. Used as the post-sync refresh for the screens that render from
 * patientInfo rather than from local state (InfoCard, the Profile modal),
 * mirroring what PatientManagement does on patient open.
 *
 * `notes` and `firstTimeNotesVisit` are carried over from the current state:
 * they come from the clinical-notes API and from navigation, not from
 * demographics, so re-formatting the demographic response would blank them.
 *
 * `ehrPatientId` and `lastEhrVisitDate` sit beside `patients` in the response
 * rather than inside it, so they are lifted in here the same way the patient
 * screen does on open. Formatting `patients` alone would blank both.
 */
const refreshPatientInfo: (
  dispatch: any,
  patientInfo: PatientInfoType
) => Promise<void> = async (dispatch, patientInfo) => {
  if (!patientInfo?.id) return;
  const res = await PatientApi.demographic({ id1: patientInfo.id });
  if (res?.success) {
    const formateRes = PatientFormatter.FormatePatientInfo({
      ...res?.data?.patients,
      ehrPatientId: res?.data?.ehrPatientId,
      lastEhrVisitDate: res?.data?.lastEhrVisitDate,
    });
    dispatch(
      addPatientInfo({
        ...formateRes,
        notes: patientInfo.notes,
        firstTimeNotesVisit: patientInfo.firstTimeNotesVisit,
      })
    );
  }
};

export default refreshPatientInfo;
